// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

/**
 * Create a new email
 * @param {*} params
 * @returns
 */
function createEmail(params: any): any {
    const { parent, id, data } = params;
    // console.log('DATA API HELPER', data);
    var baseUrl;
    if (parent && id) {
        baseUrl = `${config.server.api}/v1/${parent}/${id}/emails`;
    } else {
        baseUrl = `${config.server.api}/v1/emails`;
    }
    return api.create(`${baseUrl}`, data);
}

/**
 * Update the details of a email
 * @param {*} id
 * @param {*} data
 * @param {*} params
 * @returns
 */
function updateEmail(params: any): any {
    const { id, data } = params;
    const baseUrl = `${config.server.api}/v1/emails/${id}`;
    return api.updatePatch(`${baseUrl}`, data);
}

/**
 * Get a single email
 * @param {*} id
 * @param {*} data
 * @param {*} params
 * @returns
 */
function getEmail(params: any): any {
    const { id } = params;
    const baseUrl = `${config.server.api}/v1/emails/${id}`;
    return api.get(`${baseUrl}`);
}

/**
 * Get all emails for a listing
 * @param {*} id
 * @param {*} data
 * @param {*} params
 * @returns
 */
function getEmails(params: any): any {
    const { parent, id } = params;
    var baseUrl;
    if (parent && id) {
        baseUrl = `${config.server.api}/v1/${parent}/${id}/emails`;
    } else {
        baseUrl = `${config.server.api}/v1/emails`;
    }
    return api.get(`${baseUrl}`);
}

/**
 * Get all emails submitted by a given user
 * @param {*} id
 * @param {*} data
 * @param {*} params
 * @returns
 */
function getEmailsByUser(params: any): any {
    const { user } = params;
    const baseUrl = `${config.server.api}/v1/users/${user}/emails`;
    return api.get(`${baseUrl}`);
}

/**
 * Get all emails for a listing
 * @param {*} id
 * @param {*} data
 * @param {*} params
 * @returns
 */
function getEmailsByListing(params: any): any {
    const { listing } = params;
    const baseUrl = `${config.server.api}/v1/listings/${listing}/emails`;
    return api.get(`${baseUrl}`);
}

/**
 * Get all emails for a task
 * @param {*} id
 * @param {*} data
 * @param {*} params
 * @returns
 */
function getEmailsByTask(params: any): any {
    const { task } = params;
    const baseUrl = `${config.server.api}/v1/tasks/${task}/emails`;
    return api.get(`${baseUrl}`);
}

/**
 * Get all emails for a transaction
 * @param {*} id
 * @param {*} data
 * @param {*} params
 * @returns
 */
function getEmailsByTransaction(params: any): any {
    const { transaction } = params;
    const baseUrl = `${config.server.api}/v1/transactions/${transaction}/emails`;
    return api.get(`${baseUrl}`);
}

/**
 * Create a new comment on a email
 * @param {*} params
 * @returns
 */
function createEmailAttachment(params: any): any {
    const { id, data } = params;
    const baseUrl = `${config.server.api}/v1/emails/${id}/attachments`;
    return api.create(`${baseUrl}`, data);
}

export {
    createEmail,
    updateEmail,
    getEmail,
    getEmails,
    getEmailsByListing,
    getEmailsByTask,
    getEmailsByTransaction,
    getEmailsByUser,
    createEmailAttachment,
};
